import { i18n } from "@/plugins/i18n"

/**
 * Generates a table of coordinates for a given route.
 *
 * @param {Route} route - The route containing coordinates
 * @return {HTMLElement} - The table of coordinate values
 */
export default function generateRouteCoordinatesListTable(route) {
  const table = document.createElement('table')
  table.classList.add('route-prf-coordinates-table')

  const tableHead = document.createElement('thead')
  const tableHeadRow = document.createElement('tr')

  const heads = [
    i18n.t('routePDF.tableColumnNumber'),
    i18n.t('routePDF.tableColumnCoordinate'),
    i18n.t('routePDF.tableColumnStreet'),
    i18n.t('routePDF.tableColumnRegion')
  ]

  heads.forEach((head) => {
    const headCell = document.createElement('th')
    headCell.innerText = head

    tableHeadRow.appendChild(headCell)
  })

  tableHead.appendChild(tableHeadRow)
  table.appendChild(tableHead)

  const tableBody = document.createElement('tbody')

  const coordinates = route.coordinates
  const tableBodyRows = coordinates.map((coordinate, index) => generateRouteCoordinateTableRow(coordinate, index))

  tableBodyRows.forEach((tableRow) => {
    tableBody.appendChild(tableRow)
  })

  table.appendChild(tableBody)

  return table
}

/**
 * Generate a table row for a given coordinate to be displayed in a route coordinate table.
 *
 * @param {Coordinate} coordinate - The coordinate to generate the table row for.
 * @param {Number} index - The position index of the coordinate in the route.
 *
 * @return {HTMLElement} - The created HTML <tr> element containing the coordinate value.
 */
export function generateRouteCoordinateTableRow(coordinate, index) {
  const tableRow = document.createElement('tr')
  const values = [
    index + 1,
    [coordinate.lat, coordinate.lng]
      .map((value) => Math.floor(value * (10 ** 6)) / (10 ** 6))
      .join(', '),
    coordinate.streetLabelText || '-',
    coordinate.region?.name || '-'
  ]

  values.forEach((value) => {
    const valueCell = document.createElement('td')
    valueCell.innerText = value
    valueCell.style.fontFamily = 'sans-serif'

    tableRow.appendChild(valueCell)
  })

  return tableRow
}